import { l as a } from "../../../_virtual/leaflet-src.js";
import { createTileLayerComponent as l } from "../../@react-leaflet/core/lib/generic.js";
import { updateGridLayer as n } from "../../@react-leaflet/core/lib/grid-layer.js";
import { withPane as m } from "../../@react-leaflet/core/lib/pane.js";
import { createElementObject as c } from "../../@react-leaflet/core/lib/element.js";
const T = l(function({ url: t, ...o }, e) {
  const r = new a.TileLayer(t, m(o, e));
  return c(r, e);
}, function(t, o, e) {
  n(t, o, e);
  const { url: r } = o;
  r != null && r !== e.url && t.setUrl(r);
});
export {
  T as TileLayer
};
